// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".socket .el-scrollbar__wrap{overflow-x:hidden!important}.socket .el-scrollbar__bar.is-vertical,.socket .el-scrollbar__bar.is-vertical .el-scrollbar__thumb{width:8px}.socket .el-scrollbar__bar .el-scrollbar__thumb{border-radius:8px}", ""]);
// Exports
module.exports = exports;
